import { CustomerType, } from './types';
export class Customer {
    constructor(customerId, type, name, subsegmentValue, payer, contactNumber, myBusinessComponent, subscriptionType, customerAccountNumber, mcsSubsegment, prepaid, implicit, prime) {
        this.customerId = customerId;
        this.type = type;
        this.name = name;
        this.subsegmentValue = subsegmentValue;
        this.payer = payer;
        this.contactNumber = contactNumber;
        this.myBusinessComponent = myBusinessComponent;
        this.subscriptionType = subscriptionType;
        this.customerAccountNumber = customerAccountNumber;
        this.mcsSubsegment = mcsSubsegment;
        this.prepaid = prepaid;
        this.implicit = implicit;
        this.prime = prime;
    }
    get subsegment() {
        if (!this.subsegmentValue && this.type === CustomerType.MCS) {
            // Note: mcsSubsegment used as a fallback in case there is no subsegmentValue.
            this.subsegmentValue = this.mcsSubsegment;
        }
        if (this.subsegmentValue) {
            if (this.subsegmentValue.match(/11|12|13|RES/)) {
                return 'RES';
            }
            else if (this.subsegmentValue.match(/PRE/)) {
                return 'PRE';
            }
            else if (this.subsegmentValue.match(/22|23|31|32|COR/)) {
                return 'COR';
            }
            else if (this.subsegmentValue.match(/24|25|SE|ME|BUS/)) {
                return 'BUS';
            }
        }
        return '';
    }
}
